<script>
import { saveComponentRef } from '@/placeholders/utils/ref'
import { EVENT_COMPONENT_SELECT, EVENT_COMPONENT_TRANSFORM } from './event-enums'
import CellTransformBox from '@/components/TransformBox/index.vue'
import ComponentImpl from './component-impl'

/**
 * 畫布控件包裝器組件
 *
 * 負責包裝單個控件，提供變換功能（拖動、縮放、旋轉）
 * 處理控件的選中、變換事件，並根據使用者類型設置控件顏色
 */
export default {
  name: 'CanvasCellWrapper',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  mounted() {
    let self
    // 保存控件的引用，方便直接對控件進行操作
    saveComponentRef(this.item.id, this.$refs.cell)
    if (
      this.item.extra.type === 'relationshiptopatient' &&
      document.getElementById(this.item.id + '_relationship') !== null
    ) {
      self = this
      document.getElementById(this.item.id + '_relationship').onclick = function () {
        //  alert("The paragraph was double-clicked.");
        self.eventbus.$emit('dialog:showrelationship', self.item)
      }
    }

    if (this.item.extra.type === 'signature' && document.getElementById(this.item.id) !== null) {
      self = this
      document.getElementById(this.item.id).ondblclick = function () {
        //  alert("The paragraph was double-clicked.");
        self.eventbus.$emit('dialog:showsign', self.item)
      }
    }
  },
  methods: {
    /**
     * 處理變換事件
     * @param {Event} e - 事件對象
     * @param {Object} transform - 變換信息
     */
    handler(e, transform) {
      e.stopPropagation()
      e.preventDefault()
      this.eventbus.$emit(EVENT_COMPONENT_TRANSFORM, { type: this.handleType, transform })
    },
    /**
     * 選中前的回調函數
     * 觸發控件選中事件
     * @returns {boolean} 返回 true 允許選中
     */
    beforeActive1() {
      this.handleType = 'beforeactive'
      this.eventbus.$emit(EVENT_COMPONENT_SELECT, this.item)
      return true
    },
    /**
     * 處理拖動開始事件
     * 如果是未命名輸入框，顯示命名對話框；否則聚焦輸入框
     * @param {Event} e - 事件對象
     * @param {Object} t - 變換信息
     */
    handleDragStart(e, t) {
      if (this.item.extra.inputType === 'input' && this.item.extra.fieldname === undefined) {
        this.eventbus.$emit('dialog:showFieldName')
      } else if (this.item.extra.inputType === 'input' && document.getElementById(this.item.id) !== null) {
        document.getElementById(this.item.id).focus()
        document.getElementById(this.item.id + '_div ').focus()
      }
      if (this.item.extra.inputType === 'date' || this.item.extra.inputType === 'datetime') {
        document.getElementById(this.item.id).focus()
      }

      this.handleType = 'dragstart'
      this.handler(e, t)
    },
    /**
     * 處理拖動事件
     * @param {Event} e - 事件對象
     * @param {Object} t - 變換信息
     */
    handleDrag(e, t) {
      this.handleType = 'drag'
      this.handler(e, t)
    },
    /**
     * 處理拖動結束事件
     * @param {Event} e - 事件對象
     * @param {Object} t - 變換信息
     */
    handleDragEnd(e, t) {
      this.handleType = 'dragend'
      this.handler(e, t)
    },
    /**
     * 處理縮放開始事件
     * @param {Event} e - 事件對象
     * @param {Object} t - 變換信息
     */
    handleResizeStart(e, t) {
      this.handleType = 'resizestart'
      this.handler(e, t)
    },
    /**
     * 處理縮放事件
     * @param {Event} e - 事件對象
     * @param {Object} t - 變換信息
     */
    handleResize(e, t) {
      this.handleType = 'resize'
      this.handler(e, t)
    },
    /**
     * 處理縮放結束事件
     * @param {Event} e - 事件對象
     * @param {Object} t - 變換信息
     */
    handleResizeEnd(e, t) {
      this.handleType = 'resizeend'
      this.handler(e, t)
    },
    /**
     * 處理旋轉開始事件
     * @param {Event} e - 事件對象
     * @param {Object} t - 變換信息
     */
    handleRotateStart(e, t) {
      this.handleType = 'rotatestart'
      this.handler(e, t)
    },
    /**
     * 處理旋轉事件
     * @param {Event} e - 事件對象
     * @param {Object} t - 變換信息
     */
    handleRotate(e, t) {
      this.handleType = 'rotate'
      this.handler(e, t)
    },
    /**
     * 處理旋轉結束事件
     * @param {Event} e - 事件對象
     * @param {Object} t - 變換信息
     */
    handleRotateEnd(e, t) {
      this.handleType = 'rotateend'
      this.handler(e, t)
    },
    /**
     * 渲染控件內容
     * 根據使用者類型設置控件顏色，並動態渲染對應的控件組件
     * @returns {VNode} 渲染的控件組件
     */
    renderContent() {
      const extra = this.item.extra
      const DynamicComponent = ComponentImpl[extra.type]

      // 根據使用者類型設置控件顏色
      if (extra.usertype === 'Main Signer') {
        extra.color = '#FFE48F'
        extra.borderColor = '#be8f05'
      } else if (extra.usertype === 'Doctor') {
        extra.color = '#AFF995'
        extra.borderColor = '#be8f05'
      } else if (extra.usertype === 'Witness1') {
        extra.color = '#8FF2FF'
        extra.borderColor = '#be8f05'
      } else if (extra.usertype === 'Witness2') {
        extra.color = '#B4C7E7'
        extra.borderColor = '#be8f05'
      }
      return (
        <div class="component-impl">
          <DynamicComponent meta={this.item} params={extra} />
        </div>
      )
    }
  },
  render() {
    const item = this.item
    return (
      <CellTransformBox
        ref="cell"
        data-component={true}
        grid={item.grid}
        axis={item.axis}
        key={item.id}
        id={item.id}
        inputType={item.extra.inputType}
        disabled={item.extra.disabled}
        draggable={item.draggable}
        rotatable={item.rotatable}
        resizable={item.resizable}
        parent={item.parent}
        acceptRatio={item.acceptRatio}
        resizeHandler={item.resizeHandler}
        minWidth={item.minWidth}
        minHeight={item.minHeight}
        active={item.active}
        value={item.transform}
        zoom={item.zoom}
        beforeActive={this.beforeActive1}
        onDragstart={this.handleDragStart}
        onDrag={this.handleDrag}
        onDragend={this.handleDragEnd}
        onResizestart={this.handleResizeStart}
        onResize={this.handleResize}
        onResizeend={this.handleResizeEnd}
        onRotatestart={this.handleRotateStart}
        onRotate={this.handleRotate}
        onRotateend={this.handleRotateEnd}
        renderContent={this.renderContent}
      />
    )
  }
}
</script>

<style lang="scss" scoped>
.component-impl {
  position: absolute;
  user-select: none;

  ::v-deep {
    .el-input__inner {
      height: inherit;
    }
  }
}
</style>
